import { render } from "./OtpModal.vue?vue&type=template&id=26a372ee&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"

import "./OtpModal.vue?vue&type=style&index=0&id=26a372ee&lang=scss"
import "./OtpModal.vue?vue&type=style&index=1&id=26a372ee&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a372ee"]])

export default __exports__